import featureFlags from "@/mixins/featureFlags";

export default {
  mixins: [featureFlags],
  computed: {
    backgroundClass() {
      return this.isPerformxLogoEnabled() ? "background-gradient" : "gradient-background";
    },
  },
};
